import LeagueSettingsScreen from '@/screens/LeagueSettingsScreen';
import { LeagueManagerRouteGate } from '@/components/route/RouteGate';
import { useLeagueContext } from '@/contexts/LeagueContext';

export default function LeagueSettingsRoute() {
  const { id: leagueId } = useLeagueContext();

  return (
    <LeagueManagerRouteGate leagueId={leagueId}>
      <LeagueSettingsScreen />
    </LeagueManagerRouteGate>
  );
}
